import isArray from 'lodash/isArray'
import isObject from 'lodash/isObject'
import isString from 'lodash/isString'
import { moneyFromFormValue } from '@klear/ui/components/money-form-value'
import { PAYMENT_LINE_ITEM_TYPES, type PaymentLineItemType } from '@klear/payment/constants'
import type { PaymentItemWire } from '@klear/payment/item.wire'

type UrlLineItem = {
  t: string
  a: string
  n?: string
}

function isLineItemType(value: string): value is PaymentLineItemType {
  return (PAYMENT_LINE_ITEM_TYPES as readonly string[]).includes(value)
}

export function lineItemsToQuery(items: PaymentItemWire[]): string | null {
  if (items.length === 0) return null
  const compact: UrlLineItem[] = items.map((item) => ({
    t: item.type,
    a: item.amount,
    n: item.note || undefined
  }))
  return JSON.stringify(compact)
}

export function lineItemsFromQuery(raw: string | null): PaymentItemWire[] {
  if (raw == null || raw === '') return []
  let parsed: unknown
  try {
    parsed = JSON.parse(raw)
  } catch {
    return []
  }
  if (!isArray(parsed)) return []

  const items: PaymentItemWire[] = []
  for (const entry of parsed) {
    if (!isObject(entry)) continue
    const { t, a, n } = entry as Partial<UrlLineItem>
    if (!isString(t) || !isLineItemType(t)) continue
    const amount = moneyFromFormValue(a)
    if (amount == null) continue
    items.push({
      type: t,
      amount: amount.toJSON(),
      note: isString(n) && n.length > 0 ? n : undefined
    })
  }
  return items
}
